import { IconCopy } from "components/icons/IconCopy";
import * as React from "react";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";
import { useMprcTheme } from "../MprcThemeProvider";


export const IconButtonCopy: React.FC<MprcIconButtonProps> = ({ title, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonCopy.title;

    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <IconCopy fixedWidth  />
        </MprcIconButton>
    );
};
